import { NgModule } from "@angular/core";
import { NgSelectModule } from "@ng-select/ng-select";
import { TranslateModule, TranslatePipe } from "@ngx-translate/core";
import { IonicModule, IonicPageModule } from "ionic-angular";
import { CommonComponentsModule } from "../components/common/common-components.module";
import { ComponentsModule } from "../components/components.module";
import { OrderPopupComponent } from "../components/orders/order-popup/order-popup";
import { PrnCommentPopover } from "../pages/assessment/prn-comment-popover/prn-comment-popover";
import { PrnCommentPopoverModule } from "../pages/assessment/prn-comment-popover/prn-comment-popover.module";
import { HuvNotification } from "../pages/assessment/visits/huv-notification/huv-notification";
import { CreateIDGMeetingModalPage } from "../pages/inter-disciplinary-group/create-idg-meeting-modal/create-idg-meeting-modal";
import { CreateIDGMeetingModalPageModule } from "../pages/inter-disciplinary-group/create-idg-meeting-modal/create-idg-meeting-modal.module";
import { GenerateRisklabelPipe } from "../pipes/community-bereavement/generate-risklabel.pipe";
import { IDGDataService } from "../providers/idg-data-service/idg-data-service";
import { PatientPreVisitSummaryService } from "../providers/patient-charts/patient-pre-visit-summary-service";
import { AlertsPopoverPage } from "./components/alerts-popover/alerts-popover";
import { AppsPopoverPage } from "./components/apps-popover/apps-popover";
import { BriefBarComponent } from "./components/brief-bar/brief-bar";
import { CalendarBriefBarComponent } from "./components/calendar-brief-bar/calendar-brief-bar";
import { CalendarNotificationsPopoverPage } from "./components/calendar-notifications-popover/calendar-notifications-popover";
import { CalendarPopoverComponent } from "./components/calendar-popover/calendar-popover";
import { CreateVisitOffline } from "./components/create-visit-offline/create-visit-offline";
import { DashboardNavigationBarComponent } from "./components/dashboard-navigation-bar/dashboard-navigation-bar";
import { EditViewPopoverPage } from "./components/edit-view-popover/edit-view-popover";
import { EditViewPopoverPageModule } from "./components/edit-view-popover/edit-view-popover.module";
import { IDGDareComponent } from "./components/idg-dare/idg-dare";
import { NavigationBarComponent } from "./components/navigation-bar/navigation-bar";
import { NavigationHeaderComponent } from "./components/navigation-header/navigation-header";
import { PatientSummary } from "./components/patient-summary/patient-summary";
import { StatusViewPopoverPage } from "./components/status-view-popover/status-view-popover";
import { StatusViewPopoverPageModule } from "./components/status-view-popover/status-view-popover.module";
import { UserPopoverPage } from "./components/user-popover/user-popover";
import { UserPopoverPageModule } from "./components/user-popover/user-popover.module";
import { VisitsPageNavigation } from "./components/visit-page-navigation/visit-page-navigation";
import { NavigationDataService } from "./services/navigation-data.service";

@NgModule({
  declarations: [
    AlertsPopoverPage,
    AppsPopoverPage,
    CalendarPopoverComponent,
    CalendarNotificationsPopoverPage,
    BriefBarComponent,
    IDGDareComponent,
    DashboardNavigationBarComponent,
    NavigationBarComponent,
    NavigationHeaderComponent,
    CreateVisitOffline,
    VisitsPageNavigation,
    GenerateRisklabelPipe,
    CalendarBriefBarComponent,
    HuvNotification,
    PatientSummary,
  ],
  imports: [
    IonicModule,
    UserPopoverPageModule,
    EditViewPopoverPageModule,
    StatusViewPopoverPageModule,
    PrnCommentPopoverModule,
    ComponentsModule,
    TranslateModule.forChild(),
    IonicPageModule.forChild(AppsPopoverPage),
    IonicPageModule.forChild(CalendarNotificationsPopoverPage),
    IonicPageModule.forChild(CalendarPopoverComponent),
    CommonComponentsModule,
    NgSelectModule,
    CreateIDGMeetingModalPageModule,
  ],
  entryComponents: [
    AlertsPopoverPage,
    PatientSummary,
    AppsPopoverPage,
    CalendarPopoverComponent,
    CalendarNotificationsPopoverPage,
    UserPopoverPage,
    EditViewPopoverPage,
    StatusViewPopoverPage,
    PrnCommentPopover,
    UserPopoverPage,
    OrderPopupComponent,
    CreateIDGMeetingModalPage,
  ],
  exports: [
    IDGDareComponent,
    BriefBarComponent,
    DashboardNavigationBarComponent,
    NavigationBarComponent,
    NavigationHeaderComponent,
    CreateVisitOffline,
    VisitsPageNavigation,
    GenerateRisklabelPipe,
    CalendarBriefBarComponent,
    HuvNotification,
  ],
  providers: [
    NavigationDataService,
    TranslatePipe,
    IDGDataService,
    PatientPreVisitSummaryService,
  ],
})
export class NavigationModule {}



// WEBPACK FOOTER //
// ./src/navigation/navigation.module.ts